import React from "react";

export default function DashboardProposalsDetail({ proposalsAnalytics }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5 mt-4 lg:mt-6 mb-4 lg:mb-6 min-w-0">
      <div className="sm:col-span-2 bg-white rounded-xl shadow-md border border-gray-100 p-4 min-w-0">
        <h2 className="text-base sm:text-lg font-main font-bold text-left text-black mb-3">
          Daily Proposals
        </h2>
        <div className="grid grid-cols-2 gap-3 sm:gap-4">
          <div className="flex flex-col p-3 sm:p-4 gap-1 sm:gap-2 font-main rounded-xl border border-gray-200 bg-gray-50/50">
            <p className="text-gray-700 font-[500] text-xs sm:text-sm">Sent Proposals</p>
            <p className="text-2xl sm:text-3xl font-bold">
              {proposalsAnalytics?.today_proposals ?? 0}
            </p>
          </div>
          <div className="flex flex-col p-3 sm:p-4 gap-1 sm:gap-2 font-main rounded-xl border border-gray-200 bg-gray-50/50">
            <p className="text-gray-700 font-[500] text-xs sm:text-sm">Accepted Proposals</p>
            <p className="text-2xl sm:text-3xl font-bold">
              {proposalsAnalytics?.today_accepted_proposals ?? 0}
            </p>
          </div>
        </div>
      </div>

      <div className="sm:col-span-2 bg-white rounded-xl shadow-md border border-gray-100 p-4 min-w-0">
        <h2 className="text-base sm:text-lg font-main font-bold text-left text-black mb-3">
          Monthly Proposals
        </h2>
        <div className="grid grid-cols-2 gap-3 sm:gap-4">
          <div className="flex flex-col p-3 sm:p-4 gap-1 sm:gap-2 font-main rounded-xl border border-gray-200 bg-gray-50/50">
            <p className="text-gray-700 font-[500] text-xs sm:text-sm">Sent Proposals</p>
            <p className="text-2xl sm:text-3xl font-bold">
              {proposalsAnalytics?.month_proposals ?? 0}
            </p>
          </div>
          <div className="flex flex-col p-3 sm:p-4 gap-1 sm:gap-2 font-main rounded-xl border border-gray-200 bg-gray-50/50">
            <p className="text-gray-700 font-[500] text-xs sm:text-sm">Accepted Proposals</p>
            <p className="text-2xl sm:text-3xl font-bold">
              {proposalsAnalytics?.month_accepted_proposals ?? 0}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
